import axios from "axios";

export const fetchDisableCompanies = async (data: any) => {
  return await axios.post("/api/company/disable", data);
};
